import { render, staticRenderFns } from "./AddExercisesDialog.vue?vue&type=template&id=596f8db6&scoped=true"
import script from "./AddExercisesDialog.vue?vue&type=script&lang=js"
export * from "./AddExercisesDialog.vue?vue&type=script&lang=js"
import style0 from "./AddExercisesDialog.vue?vue&type=style&index=0&id=596f8db6&prod&lang=css"
import style1 from "./AddExercisesDialog.vue?vue&type=style&index=1&id=596f8db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f8db6",
  null
  
)

export default component.exports